/**
 * @desc This enables endless scrolling on the target listview or UL
 * @author Parag Majumdar
 * @param {{jQuery Object}} $el
 * @param {{String}} tmpl - The template which will be used to create appends
 * @param {{Object}} options - Options (See usage below)
 * @usage:
 *  a) Create an infinite list object: var myList = new InfiList($('#myList'), tmpl)
 *  b) Bind a scroll end method to it: myList.onScroll(appendMyData, someOptionalData) - that checks when scroll happens and runs 'appendMyData' when it reaches the threshold of scroll. The method 'appendMyData' contains a call to 'append' of 'myList' to do the actual DOM insertion e.g:
 *     function appendMyData(someOptionalData){
 * 			$.ajax(url).done(function(response){
 * 				myList.append(response);
 * 			})
 * 		}
 *  You can also chain:  new InfiList($('#myList'), template).onScroll(appendMyData)
 *  Default options for the infinite list:
 *    {
			tmplr : 'Mustache' // default templating engine e.g Mustache, underscore, $
			,delay : 200 // call the scrollend function after a delay of 200ms
			,threshold : 200  // How many pixels before the screen should the appending function be called
			,listItem : '.resultRow'  //the class name of the listitem or html that will be repeated while appending
			,spinner : '#loadMoreSpinner'  // The 'loading more results' kinda spinner
		}
 */
!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (typeof module != 'undefined' && module.exports) module.exports = module()
  	else if (typeof context['define'] === 'function' && context['define']['amd']) define('libs/ct_infilist',['underscore', !window.$? 'jquery' : '', 'vendor/mustache'], module) //Add 'InfiList' dependencies here
  	else
  	//>>excludeEnd("requireTmpl");
  		context[name] = module(_, window.jQuery, Mustache)
}('InfiList', function(_, $, Mustache){
	_ = _ || window._ || {}
	$ = $ || window.$

	var InfiList = function($el, tmpl, options){
		var defaults = {
			tmplr : 'Mustache' // default templating engine e.g Mustache, underscore, $
			,delay : 200
			,threshold : 200
			,listItem : '.listItem'
			,spinner : '#loadMore'
			,positionSpinner : 'append'
		}
		return new InfiList.prototype.setup($el, tmpl, _.extend(defaults, options || {}))
	}
	InfiList.prototype = {
		constructor : InfiList,






		templating : {
			'Mustache' : 'to_html',
			'_' : 'template',
			'CT' : 'to_html'
		},









		_append : function($list, data){

			var self = this,
				tmpl = self._tmpl,
				tmplr = self.options.tmplr,
				pos = self.options.positionSpinner,
				method = self.templating[tmplr],
				partials = self.partial,
				allowScroll = self.options.allowScroll,
				isInvalid = function(data){
					if(_.isArray(data) && data.length === 0) return true
					else if(!data) return true
					else if(allowScroll){
						if(allowScroll(data)) return false
						else return true
					}
					else return false
				},
				appendFn;

			//if(tmplr === "Mustache") {
			if(pos === 'after')
				appendFn = function(list, data){
					if(isInvalid(data)) return $(self.options.spinner).hide();
					list.append(typeof tmpl === 'function'? tmpl(data, partials) : Mustache.to_html(tmpl, data, partials))
				}
			else if(pos === 'append')
				appendFn = function(list, data){
					var $spinner = self.spinner.call(self);
					if(isInvalid(data)) return $(self.options.spinner).hide();
					$spinner.before(typeof tmpl === 'function'? tmpl(data, partials) : Mustache.to_html(tmpl, data, partials))
				}
			//}
			appendFn($list, data);
			this._append = appendFn;
			return this;
			//$spinner.before(window[tmplr][method](tmpl, data))
		},









		//@return The spinner jQuery object
		spinner : _.memoize(function(){
			var opts = this.options;
			var spinnerId = opts.spinner, $spinner;
			if(($spinner = $(spinnerId)).length > 0) return $spinner;
			else {
				//this._lists[opts.positionSpinner]('<div class="pad loadingModal" id="loadMore"><h3>Hang on, fetching more results...</h3></div>')
				if(window.isMobileUA && window.isMobileUA == true){
					this._lists[opts.positionSpinner]('<div class="loadMsg loadingModal loadingResults" id="loadMore"><div class="loadingContainer"><div class="spinner"></div></div><strong>Hang on...</strong> <span>fetching more results...</span></div>')
				} else {
					this._lists[opts.positionSpinner]('<div class="pad loadingModal" id="loadMore"><h3>Hang on, fetching more results...</h3></div>')
				}
				return $(spinnerId);
			}

		}),





		setup : function($el, tmpl, options){
			if(typeof $el === "undefined" || $el === null) $el = $('<div id="ct_infiList"></div>').appendTo('body');
			this._lists = $el;
			this._tmpl = tmpl;
			this.options = options;
			this.infId = '.' + new Date().getTime();
			if(options.method) this.templating[options.tmplr] = options.method;
			if(options.partial) this.partial = options.partial
			return this;
		},










		each : function(fn){
			this._lists.each(fn)
			return this;
		},








		onScroll : function(fn, data){
			this._onSuccess = this._onSuccess || fn;
			data = this._onSuccess.data = this._onSuccess && this._onSuccess.data || _.extend({ page : 1 }, data || {});
			$(window).bind('scroll.infiList' + this.infId, _.debounce(_.bind(function(){
				var $lists = this._lists, opt = this.options;
				var vis_bottom = $(document).scrollTop() + $(window).height()
				for(var i = 0, l = $lists.length, $el; i < l && ($el = $($lists[i])) !== false; i++){ //Avoided functional iterator to minimize closures
					var top_of_results = $el.offset().top
					var $last_result = $el.find(opt.listItem).last()
					var bottom_of_results = $last_result.outerHeight() + $last_result.offset().top

					this.spinner.call(this).show();

					if(bottom_of_results - vis_bottom < opt.threshold) {
						var settings = this._onSuccess.data;
						settings.page += 1;
						this._onSuccess.call(data.context || this, this._onSuccess.data)
					}
				}
			}, this), this.options.delay));
			return this;
		},









		append : function(/* JSON or String or DOM */data){
			for(var i = 0, l = this._lists.length, lists = this._lists, list = lists[0]; i < l && (list = lists[i]); i++) this._append($(list), data)
			return this;
		},










		stop : function(){
			$(window).unbind('scroll.infiList' + this.infId);
			$(this.options.spinner).hide();
			return this
		},






		restart : function(){
			this.onScroll()
		}
	}
	InfiList.prototype.setup.prototype = InfiList.prototype;



	return InfiList;
}, this);

